/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Section_Status_AcceptedInputs */

const en_jobs_section_status_accepted = /** @type {(inputs: Jobs_Section_Status_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepted`)
};

const de_jobs_section_status_accepted = /** @type {(inputs: Jobs_Section_Status_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akzeptiert`)
};

const fr_jobs_section_status_accepted = /** @type {(inputs: Jobs_Section_Status_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepté`)
};

const es_jobs_section_status_accepted = /** @type {(inputs: Jobs_Section_Status_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptado`)
};

const it_jobs_section_status_accepted = /** @type {(inputs: Jobs_Section_Status_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accettato`)
};

const nl_jobs_section_status_accepted = /** @type {(inputs: Jobs_Section_Status_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geaccepteerd`)
};

const pl_jobs_section_status_accepted = /** @type {(inputs: Jobs_Section_Status_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaakceptowano`)
};

const fi_jobs_section_status_accepted = /** @type {(inputs: Jobs_Section_Status_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyväksytty`)
};

const da_jobs_section_status_accepted = /** @type {(inputs: Jobs_Section_Status_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepteret`)
};

const sv_jobs_section_status_accepted = /** @type {(inputs: Jobs_Section_Status_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godkänt`)
};

/**
* | output |
* | --- |
* | "Accepted" |
*
* @param {Jobs_Section_Status_AcceptedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_section_status_accepted = /** @type {((inputs?: Jobs_Section_Status_AcceptedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Section_Status_AcceptedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_section_status_accepted(inputs)
	if (locale === "fr") return fr_jobs_section_status_accepted(inputs)
	if (locale === "es") return es_jobs_section_status_accepted(inputs)
	if (locale === "it") return it_jobs_section_status_accepted(inputs)
	if (locale === "nl") return nl_jobs_section_status_accepted(inputs)
	if (locale === "pl") return pl_jobs_section_status_accepted(inputs)
	if (locale === "fi") return fi_jobs_section_status_accepted(inputs)
	if (locale === "da") return da_jobs_section_status_accepted(inputs)
	if (locale === "sv") return sv_jobs_section_status_accepted(inputs)
	return en_jobs_section_status_accepted(inputs)
});